import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';
import { AddOrEditSuperAdministratorComponent } from './add-or-edit-super-administrator/add-or-edit-super-administrator.component';
import { DeleteSuperAdministratorComponent } from './delete-super-administrator/delete-super-administrator.component';
import { TranslateService } from "@ngx-translate/core";
import { SuperAdministratorModel } from 'src/app/admin-panel/models/system-profiles/super-administrator.model';
import { SearchSuperAdministratorModel } from 'src/app/admin-panel/models/system-profiles/search-super-administrator.model';

@Component({
  selector: 'app-super-administrator',
  templateUrl: './super-administrator.component.html',
  styleUrls: ['./super-administrator.scss']
})
export class SuperAdministratorComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
  public superAdministratorList : Array<SuperAdministratorModel>;
  public searchSuperAdministratorModel: SearchSuperAdministratorModel = new SearchSuperAdministratorModel();
  public totalPages: number;
  public totalRecords: number;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public administratorService: AdministratorService,
    public translate: TranslateService,
    private messageService: MessageService
  ) {
    this.superAdministratorList = new Array<SuperAdministratorModel>();
  }

  ngOnInit(): void {
    this.getAllSuperAdmins(this.searchSuperAdministratorModel)
  }
  //#endregion
  //#region Public Methods
  getAllSuperAdmins(searchModel: SearchSuperAdministratorModel) {
    this.administratorService.getAllSuperAdmins(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.searchSuperAdministratorModel.pageNumber > 1) {
            this.superAdministratorList = this.superAdministratorList.concat(response.data)
          }
          else {
            this.superAdministratorList = response.data;
          }
        },
        error: errorResponse => {

        }
      });

  };
  loadMoreSuperAdmin(){
    this.searchSuperAdministratorModel.pageNumber = this.searchSuperAdministratorModel.pageNumber + 1;
    this.getAllSuperAdmins(this.searchSuperAdministratorModel);
  }
  addNewSuperAdmin(){
    const ref = this.dialogService.open(AddOrEditSuperAdministratorComponent, {
      header: this.translate.instant('SYSTEM_PROFILES.ADD_ADMINISTRATOR'),
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchSuperAdministratorModel.pageNumber = 1;
        this.getAllSuperAdmins(this.searchSuperAdministratorModel);
        let summary = this.translate.instant('SYSTEM_PROFILES.USER_ADDED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  editSuperAdmin(userId:string){
    const ref = this.dialogService.open(AddOrEditSuperAdministratorComponent, {
      data: {
        id: userId
      },
      header: this.translate.instant('SYSTEM_PROFILES.EDIT_ADMINISTRATOR'),
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchSuperAdministratorModel.pageNumber = 1;
        this.getAllSuperAdmins(this.searchSuperAdministratorModel);
        let summary = this.translate.instant('SYSTEM_PROFILES.USER_UPDATED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  deleteSuperAdmin(userId:string){
    const ref = this.dialogService.open(DeleteSuperAdministratorComponent, {
      data: {
        id: userId
      },
      header: this.translate.instant('SYSTEM_PROFILES.DELETE_ADMINISTRATOR'),
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchSuperAdministratorModel.pageNumber = 1;
        this.getAllSuperAdmins(this.searchSuperAdministratorModel);
        let summary = this.translate.instant('SYSTEM_PROFILES.USER_DELETED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }

  searhSuperAdmin(searchModel: SearchSuperAdministratorModel) {
    searchModel.pageNumber = 1;
    this.getAllSuperAdmins(searchModel)
  }
  clearSearch() {
    this.searchSuperAdministratorModel = new SearchSuperAdministratorModel();
    this.getAllSuperAdmins(this.searchSuperAdministratorModel);
  }
  //#endregion
  //#Private Methods
  //#endregion
}
